import { classnames } from 'helpers/utils';
import styles from './progress-bar.module.scss';

type ProgressBarProps = {
  percentageUsed: number;
  reachingLimit: boolean;
  height?: number;
};

const ProgressBar: React.FC<ProgressBarProps> = ({
  percentageUsed,
  reachingLimit,
  height = 24,
}) => (
  <div>
    <div className={classnames(styles.outsideBox)} style={{ height }}>
      <div
        style={{ width: `${percentageUsed}%` }}
        className={classnames(styles.insideBox, {
          [styles.runningOutTimeColor]: reachingLimit,
        })}
      />
    </div>
  </div>
);

export { ProgressBar };
